import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
    NavActionButtonsComponent,
    NavBasicSlidesRowComponent,
    NavBasicToggleComponent,
    NavExtensionSlidesRowComponent,
    NavExtensionToggleComponent,
} from 'shared/classroom/preview-screen/ui-beamer-nav';
import { NextSlidesPreviewFacade } from './next-slides-preview.facade';

/**
 * Classic beamer nav (TUT beamer): action buttons above a 4-column grid
 * ([‹] [thumbs] [›] [toggle] for the extension and the basic slides).
 * No floating toolbar: `app-slide-preview [floatingToolbar]` needs `[glassTheme]="true"`
 * (the floating toolbar lives in `pcp-next-slides-preview-glassmorphic`).
 * The rows, toggles and action buttons are the shared parts of `shared/classroom/preview-screen/ui-beamer-nav`,
 * wired to `NextSlidesPreviewFacade`.
 */
@Component({
    selector: 'pcp-next-slides-preview',
    templateUrl: './next-slides-preview.component.html',
    styleUrl: './next-slides-preview.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NextSlidesPreviewFacade],
    imports: [
        NavActionButtonsComponent,
        NavBasicSlidesRowComponent,
        NavBasicToggleComponent,
        NavExtensionSlidesRowComponent,
        NavExtensionToggleComponent,
    ],
})
export class NextSlidesPreviewComponent {
    protected readonly nav = inject(NextSlidesPreviewFacade);
}
